import { useCallback, useState } from 'react';

export function useLocalStorage<T>(key: string, initialValue: T) {
    const [value, setValue] = useState<T>(() => {
        try {
            const stored = window.localStorage.getItem(key);
            return stored !== null ? (JSON.parse(stored) as T) : initialValue;
        } catch {
            return initialValue;
        }
    });

    const set = useCallback(
        (next: T) => {
            setValue(() => {
                try {
                    window.localStorage.setItem(key, JSON.stringify(next));
                } catch {
                    // no-op
                }
                return next;
            });
        },
        [key],
    );

    const remove = useCallback(() => {
        try {
            window.localStorage.removeItem(key);
        } catch {
            // no-op
        }
    }, [key]);

    return [value, set, remove] as const;
}
